module.exports = __webpack_public_path__ + "files/SPIADI2018 - Rapport annuel d'activité.d0e5af852518d3ec409d4b04c6af7bfa.pdf";